module.exports = __webpack_public_path__ + "img/shouye.7a9de003.png";